module.exports = __webpack_public_path__ + "static/img/meeting.6e1b26f.png";


//////////////////
// WEBPACK FOOTER
// ./static/MRMS/images/meeting.png
// module id = 5hrf
// module chunks = 1